{
  "app": {
    "name": "ForumOne"
  },
  "actions": {
    "save": "Enregistrer",
    "update": "Mettre à jour",
    "cancel": "Annuler",
    "refresh": "Actualiser",
    "previous": "Précédent",
    "next": "Suivant",
    "markAllRead": "Tout marquer comme lu",
    "viewDetails": "Voir les détails",
    "viewAll": "Voir toutes les notifications",
    "tryAgain": "Réessayer",
    "approve": "Approuver",
    "decline": "Refuser",
    "search": "Rechercher…",
    "signOut": "Se déconnecter",
    "help": "Aide",
    "helpSupport": "Aide et support",
    "view": "Voir",
    "edit": "Modifier",
    "delete": "Supprimer"
  },
  "labels": {
    "yes": "Oui",
    "no": "Non",
    "notAvailable": "N/D"
  },
  "nav": {
    "dashboard": "Tableau de bord",
    "appointments": "Rendez-vous",
    "slotRequests": "Demandes de créneaux",
    "customers": "Clients",
    "providers": "Prestataires",
    "services": "Services",
    "finance": "Finances",
    "helpSupport": "Aide et support",
    "adCampaigns": "Campagnes publicitaires",
    "businesses": "Entreprises et institutions",
    "settings": "Paramètres",
    "tutorialGuide": "Guide tutoriel",
    "disabledNoBusiness": "Créez d'abord une entreprise ou une institution",
    "disabledPendingApproval": "Disponible une fois votre entreprise approuvée"
  },
  "adminNav": {
    "dashboard": "Tableau de bord",
    "businesses": "Entreprises et institutions",
    "services": "Services",
    "providers": "Prestataires",
    "adCampaigns": "Campagnes publicitaires",
    "pendingAdCampaigns": "Campagnes en attente",
    "appointments": "Rendez-vous",
    "customers": "Clients",
    "pendingApprovals": "Approbations en attente",
    "issueReports": "Aide et support",
    "admins": "Administrateurs système",
    "messaging": "Messagerie",
    "transactions": "Transactions",
    "payouts": "Demandes de paiement",
    "adPlans": "Plans publicitaires",
    "businessPlans": "Plans entreprise",
    "industries": "Industries",
    "settings": "Paramètres",
    "adminHome": "Administration"
  },
  "breadcrumbs": {
    "dashboard": "Tableau de bord",
    "appointments": "Rendez-vous",
    "slotRequests": "Demandes de créneaux",
    "customers": "Clients",
    "services": "Services",
    "providers": "Prestataires",
    "finance": "Finances",
    "support": "Aide et support",
    "adCampaigns": "Campagnes publicitaires",
    "business": "Entreprises et institutions",
    "settings": "Paramètres",
    "profile": "Profil",
    "password": "Mot de passe",
    "appearance": "Apparence",
    "language": "Langue",
    "notifications": "Notifications",
    "create": "Créer",
    "edit": "Modifier",
    "import": "Importer",
    "details": "Détails",
    "businesses": "Entreprises et institutions",
    "pendingApprovals": "Approbations en attente",
    "pendingAdCampaigns": "Campagnes en attente",
    "admins": "Administrateurs système",
    "messaging": "Messagerie",
    "messages": "Messages",
    "transactions": "Transactions",
    "payouts": "Demandes de paiement",
    "adPlans": "Plans publicitaires",
    "industries": "Industries"
  },
  "errors": {
    "generic": "Une erreur s'est produite",
    "required": "Obligatoire"
  },
  "commandPalette": {
    "searchPlaceholder": "Rechercher des pages et actions…",
    "empty": "Aucun résultat.",
    "groups": {
      "navigation": "Navigation",
      "actions": "Actions"
    },
    "actions": {
      "createService": "Créer un service",
      "createProvider": "Créer un prestataire",
      "createCampaign": "Créer une campagne publicitaire"
    },
    "keywords": {
      "newService": "nouveau service",
      "newProvider": "nouveau prestataire"
    },
    "admin": {
      "dashboard": "Tableau de bord admin",
      "businesses": "Entreprises",
      "services": "Services",
      "providers": "Prestataires",
      "appointments": "Rendez-vous",
      "customers": "Clients",
      "transactions": "Transactions",
      "payouts": "Paiements",
      "reports": "Aide et support",
      "messaging": "Messagerie",
      "industries": "Industries",
      "settings": "Paramètres"
    }
  },
  "businessSwitcher": {
    "label": "Entreprises et institutions",
    "businessFallback": "Entreprise ou institution",
    "noDescription": "Aucune description",
    "viewAll": "Voir toutes les entreprises et institutions",
    "importViaExcel": "Importer via Excel",
    "addBusiness": "Ajouter une entreprise ou institution",
    "ariaLabelSwitch": "Changer d'entreprise ou d'institution"
  },
  "dataTable": {
    "emptyTitle": "Aucun résultat",
    "emptyDescription": "Essayez d'ajuster votre recherche ou vos filtres.",
    "clearFilters": "Effacer les filtres",
    "filterPlaceholder": "Filtrer...",
    "view": "Affichage",
    "rowsSelected": "{{selected}} sur {{total}} ligne(s) sélectionnée(s).",
    "showingRows": "Affichage de {{shown}} sur {{total}}",
    "rowsPerPage": "Lignes par page",
    "goToFirstPage": "Aller à la première page",
    "goToPreviousPage": "Page précédente",
    "goToNextPage": "Page suivante",
    "goToLastPage": "Aller à la dernière page",
    "selectAll": "Tout sélectionner",
    "selectAllRows": "Sélectionner toutes les lignes",
    "selectRow": "Sélectionner la ligne",
    "toggleColumns": "Afficher les colonnes"
  },
  "consoleScope": {
    "adminConsole": "Console admin",
    "business": "Entreprise",
    "switchAriaLabel": "Changer de plateforme ou d'entreprise",
    "platform": "Plateforme",
    "adminDescription": "Super admin et outils plateforme",
    "yourBusinesses": "Vos entreprises",
    "noBusinesses": "Aucune entreprise liée à ce compte pour le moment.",
    "openDashboard": "Ouvrir le tableau de bord"
  },
  "modals": {
    "featureNotReadyTitle": "Fonctionnalité pas encore disponible !",
    "featureNotReadyDescription": "Cette fonctionnalité n'est pas encore prête.\nRevenez plus tard.",
    "paymentSuccessTitle": "Paiement réussi"
  }
}
